import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteComponentProps } from 'react-router';
import { ApplicationState } from '../../store';
import { withRouter } from 'react-router';
import Layout from './../Layout';
import { ToxnotReactComponentPaths } from '../core/ToxnotReactComponentPaths';
import * as BulkReportStateController from '../../store/StateControllers/BulkReport/BulkReportStateController';
import * as Table from '../core/ToxnotReactTable';
import { BulkReportState } from '../../store/StateControllers/BulkReport/BulkReportStateController';
import { InventoriesGetNamesResponse } from '../../store/Models/Api/InventoriesGetName';

import "./styles.css";
import { LoadingSpinner, LoadingSpinnerSize } from '../core/LoadingSpinner';
import { ScrollableContent, TopActionButtons, TopActionsAndScrollableContentContainer } from '../core/TopActionsAndScrollableContentContainer';
import { ToxnotComponentProperties } from '../core/BaseApplicationComponents/ToxnotComponent';
import { ToxnotSignInRequiredComponent } from '../core/BaseApplicationComponents/ToxnotSignInRequiredComponent';
import { TeamRole } from '../../store/Models/UserContext';

type BulkReportProps = BulkReportState & ToxnotComponentProperties & typeof BulkReportStateController.actionCreators & RouteComponentProps;

class BulkReport extends ToxnotSignInRequiredComponent<BulkReportProps>{
    public componentDidMount() {
        this.props.getBulkReportData();
    }

    private createRowData = (rowData: InventoriesGetNamesResponse, index: number): Table.TableRow => {
        return {
            cols: [
                <p>{rowData.name}</p>,
                <p>{<a href={this.getPreviewLink(rowData.inventoryId)} target="_blank">{this.localizeString("Preview")}</a>}</p>
            ]
        }
    }

    // ===============================================================================

    protected override getDisallowedRoles() {
        return [TeamRole.Marketing];
    }

    private getPreviewLink(inventoryId: string) {
        const reportType = this.props.reportType;

        if (reportType.startsWith("teknion-eds") || reportType.startsWith("hni-eds")) {
            // special case, can't be previewed
            return "/Api/ExportProductReport?productId=" + encodeURIComponent(inventoryId) + "&type=" + encodeURIComponent(reportType);
        }

        if (reportType === "compliance-letter" || reportType === "reach-rohs-statement") {
            return "/Data/ProductReport?productId=" + encodeURIComponent(inventoryId) + "&type=" + encodeURIComponent(reportType) + "&contextJson=" + encodeURIComponent(this.props.contextJson ?? "");
        }
        else if (reportType === "tsca-pbts-compliance") {
            return "/Data/ProductReport?productId=" + encodeURIComponent(inventoryId) + "&type=" + encodeURIComponent("reach-rohs-statement") + "&contextJson=%7B%22regulations%22%3A%5B%22tsca-pbts%22%5D%7D";
        }
        else {
            return "/Data/ProductReport?productId=" + encodeURIComponent(inventoryId) + "&type=" + encodeURIComponent(reportType);
        }
    }

    private getTableColumns = (): Table.TableColumn<InventoriesGetNamesResponse>[] => {
        return [
            {
                value: this.localizeString("Product/Material Name")
            },
            {
                value: this.localizeString("Preview")
            }
        ]
    };

    public renderConcreteComponent() {
        if (this.props.inventoryIds.length === 0) {
            return (
                <Layout options={{ pinAppContentToWindowHeight: false }}>
                    <div className="tn-section">
                        <div className="tn-section-row">
                            <div className="tn-section-col-12">
                                <div className="text-center">
                                    <LoadingSpinner size={LoadingSpinnerSize.Medium} />
                                </div>
                            </div>
                        </div>
                    </div>
                </Layout>
            );
        }

        return (
            <Layout options={{ pinAppContentToWindowHeight: true }}>
                <TopActionsAndScrollableContentContainer>
                    <TopActionButtons>
                        <div className="tn-section-padding-container padding-top-and-bottom dashed-bottom-border">
                            <div className="tn-section-row">
                                <div className="tn-section-col-12">
                                    <button type="button" onClick={this.props.generateReports} className="btn btn-toxnot-primary">{this.localizeString("Generate Reports")}</button>
                                </div>
                            </div>
                        </div>
                    </TopActionButtons>
                    <ScrollableContent>
                        <div className="tn-section-padding-container">
                            <div className="tn-section-row">
                                <div className="tn-section-col-12">
                                    <Table.ToxnotReactTable<InventoriesGetNamesResponse> allRowModels={this.props.inventoryNames ?? []} headerRow={this.getTableColumns()} getRowForTable={this.createRowData} fullSectionWidth={true} localizer={this.props.appServices} />
                                </div>
                            </div>
                        </div>
                    </ScrollableContent>
                </TopActionsAndScrollableContentContainer>
            </Layout>
        );
    }
}



export default connect(
    (state: ApplicationState) => ({ ...state.bulkReportState, appServices: state.appServices }),
    BulkReportStateController.actionCreators
)(withRouter(BulkReport) as any);